export default {
  AS: {
    "footer.button.billOfMaterials": "Liste des pièces",
    "footer.button.export": "Exportation ",
    "footer.button.printPdf": "PDF",
    "footer.button.contactSales": "Contacter le service commercial",
    "footer.button.addToWatchlist": "Ajouter à la liste de souhaits",
    "footer.button.requestQuote": "Demander une offre",
    "header.configurator.title": "Configurateur",

    "header.links.about.label": "La société",
    "header.links.about.url":
      "https://www.asecos.com/La-societe/La-societe/La-societe/FR_index_3187.html",
    "header.links.terms.label": "CGV",
    "header.links.terms.url":
      "https://www.asecos.com/Conditions-gnrales-de-ventes/FR_index_1724.html",
    "header.links.imprint.label": "Impression ",
    "header.links.imprint.url":
      "https://www.asecos.com/Mentions-lgales/FR_index_1438.html",
    "header.links.privacy.label": "Politique de confidentialité",
    "header.links.privacy.url":
      "https://www.asecos-configurator.com/FR/FR/protection-de-la-vie-prive",

    "dialog.requestQuote.title.success": "Demande envoyée",
    "dialog.requestQuote.title.requestQuote": "Demander une offre",
    "tab.billOfMaterials.title": "Liste des pièces",
    "tab.configurationSummary.title": "Résumé de la configuration",
    "dialog.requestQuote.title.contactData": "Coordonnées",
    "dialog.requestQuote.title.companyData": "Données de l'entreprise",
    "dialog.requestQuote.label.salutation": "Civilité",
    "dialog.requestQuote.select.salutation.option.female": "Madame",
    "dialog.requestQuote.select.salutation.option.male": "Monsieur",
    "dialog.requestQuote.select.salutation.option.none": "--",

    "dialog.requestQuote.label.firstName": "Prénom",
    "dialog.requestQuote.label.lastName": "Nom",
    "dialog.requestQuote.label.email": "E-mail",
    "dialog.requestQuote.label.phone": "Téléphone",
    "dialog.requestQuote.label.company": "Entreprise",
    "dialog.requestQuote.label.country": "Pays",
    "dialog.requestQuote.label.postalCode": "Code postal",
    "dialog.requestQuote.label.city": "Ville",
    "dialog.requestQuote.label.street": "Rue",
    "dialog.requestQuote.label.number": "Numéro",
    "dialog.requestQuote.label.contactHours": "Je souhaite être rappelé(e)",
    "dialog.requestQuote.checkbox.contactHours.option.morning": "Le matin",
    "dialog.requestQuote.checkbox.contactHours.option.afternoon":
      "L'après-midi",
    "dialog.requestQuote.label.specialistRetailer.header":
      "Vous pouvez enregistrer votre revendeur spécialisé privilégié ici (si vous le connaissez)",

    "dialog.requestQuote.label.specialistRetailer.salutation": "Civilité",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.female":
      "Madame",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.male":
      "Monsieur",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.none":
      "--",
    "dialog.requestQuote.label.specialistRetailer.company": "Entreprise",
    "dialog.requestQuote.label.specialistRetailer.firstName": "Prénom",
    "dialog.requestQuote.label.specialistRetailer.lastName": "Nom",
    "dialog.requestQuote.label.specialistRetailer.email": "E-mail",
    "dialog.requestQuote.label.specialistRetailer.city": "Ville",
    "dialog.requestQuote.url.privacyPolicy":
      "https://www.asecos-configurator.com/FR/FR/protection-de-la-vie-prive",
    "dialog.requestQuote.url.consentForm":
      "https://www.asecos-configurator.com/FR/FR/media/DOK_EXT_Einwilligungserklaerung-asecos-Konfigurator_IN?sprache=FR",
    "dialog.requestQuote.label.readPrivacyPolicy":
      "J’ai lu la <privacyLink>notice légale</privacyLink> et je donne mon accord. En outre, je suis d'accord avec le traitement, l'utilisation et la divulgation de mes données à un revendeur <consentLink>conformément au consentement.</consentLink>",
    "dialog.requestQuote.label.comment": "Commentaire",
    "SubconfigurationNavigation.resetItem": "Réinitialiser le groupe",
    "SubconfigurationNavigation.previousItem": "Précédent",
    "SubconfigurationNavigation.nextItem": "Suivant",
    "form.field.error.email": "Adresse e-mail invalide",
    "form.field.error.phone": "Numéro de téléphone invalide",
    "validation.required": "Ce champ est obligatoire",
    "footer.button.save": "Enregistrement",
    "footer.button.load": "Charger",

    "dialog.requestQuote.success.message":
      "Merci de l'intérêt que vous portez à asecos et à nos produits. Vous recevrez dans quelques minutes une confirmation à l'adresse e-mail que vous avez indiquée, accompagnée de vos données de configuration sous forme de fichiers PDF et JSON. Ce dernier vous permettra de rouvrir votre configuration à l'aide du bouton « Télécharger ». Les produits asecos sont vendus par des revendeurs spécialisés agréés. C'est pourquoi nous transmettons votre demande à un partenaire asecos approprié. Celui-ci vous fera parvenir une offre sans engagement correspondant à votre configuration et vous contactera si nécessaire.",
    "dialog.requestQuote.success.close": "Fermer",
    "dialog.requestQuote.error.message":
      "Une erreur s'est produite lors de l'envoi de votre demande. Veuillez réessayer plus tard.",
  },
};
